import { Tooltip } from '@ds';
import { SectionRow } from '@features/components/CaseOverview/components';

type NopServiceDetailsRowProps = {
  serviceDetails?: string | null;
  label?: string;
};

export const NopServiceDetailsRow = ({ serviceDetails, label = 'NOP Service Details' }: NopServiceDetailsRowProps) => {
  const text = serviceDetails?.trim();

  return (
    <SectionRow truncate={false} label={label}>
      {text ? (
        <Tooltip placement="top" content={<div className="max-w-75 whitespace-pre-wrap wrap-break-word">{text}</div>}>
          <span className="inline-block max-w-105 align-top">
            <span className="line-clamp-2 cursor-pointer">{text}</span>
          </span>
        </Tooltip>
      ) : (
        '-'
      )}
    </SectionRow>
  );
};
